import { Col, Row } from "antd";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import Footer from "./component/footer";
import Header from "./component/header";
import GuideLinePage from "./page/guideline";
import HomePage from "./page/home";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "guideline",
    element: <GuideLinePage />,
  },
]);

function App() {
  return (
    <Row>
      <Col xs={24} style={{ padding: '16px 24px', borderBottom: "1px solid #ddd" }}>
        <Header />
      </Col>
      <Col xs={24}>
        <RouterProvider router={router} />
      </Col>
      <div className="page-container">
        <Footer />
      </div>
    </Row>
  );
}

export default App;
